import { MergeTagsMenu } from 'modules/dynamicContentBuilder/components/contentPicker/selectedContent/CustomTextInput/mergeTagsMenu';
import { MergeTagsContextProvider } from 'modules/dynamicContentBuilder/components/contentPicker/selectedContent/CustomTextInput/contexts/mergeTags';
import { TipPlacement } from 'ui/tooltip';
import { MergeParameters16 } from 'ui/icons';
import styled from 'styled-components';
import { useState } from 'react';
import { MediumContent } from 'modules/graphql/types';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { serializeMergeTag } from 'modules/dynamicContentBuilder/components/contentPicker/selectedContent/CustomTextInput/utils/serializeMergeTag';
import { BaseToolbarButton } from 'modules/dynamicContentBuilder/components/contentPicker/selectedContent/CustomTextInput/toolbar/BaseToolbarButton';
import { concatSnippetWithTextInput, MediumDataKey } from 'modules/templateEditor/common';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MergeTagMenuButton = ({
  mediumField,
  mediumRef,
}: {
  mediumField: string;
  mediumRef?: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const showMenu = () => setIsOpen(true);
  const hideMenu = () => setIsOpen(false);
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const mediumData = (liveTemplate?.mediumData || {}) as MediumContent;

  const handleSelect = (fieldName: string) => {
    const textWithSnippet = concatSnippetWithTextInput(
      serializeMergeTag(fieldName),
      // @ts-ignore
      mediumData[mediumField],
      mediumRef,
    );
    setCurrentMediumField(mediumField as MediumDataKey, textWithSnippet);
    hideMenu();
  };

  return (
    <Wrapper data-test="merge-tag-menu-button">
      <MergeTagsContextProvider>
        <BaseToolbarButton
          isSelected={false}
          onClick={showMenu}
          tooltipPlacement={TipPlacement.Bottom}
          tooltip="Merge tag"
          data-test="merge-tag-button"
        >
          <MergeParameters16 isColorInherited />
        </BaseToolbarButton>
        {isOpen && <MergeTagsMenu onSelect={handleSelect} onClose={hideMenu} />}
      </MergeTagsContextProvider>
    </Wrapper>
  );
};
